module.exports = __webpack_public_path__ + "6117c7ce92260d8f32e002eae34de215.svg";